import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyDashboard = lazy(() => import('./Dashboard'));

export const Dashboard: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyDashboard {...props} />
	</Suspense>
);
